import { Drawer } from '@ifood/pomodoro-components';
import React, { FC, useCallback } from 'react';
import Media from 'react-media';
import Portalize from 'react-portalize';

import { useSidebar } from '@constants/globals';
import { LEFT_HEADER_PORTAL_ID_HASH } from 'modules/Header/constants';

import { MOBILE_MAX_WIDTH } from '../../constants';
import { DrawerButton } from '../DrawerButton';
import { Aside, DrawerBody } from './styles';

const SIDEBAR_MEDIA_QUERY_CONFIG = { minWidth: MOBILE_MAX_WIDTH };

type PropTypes = {
  className?: string;
};

export const Sidebar: FC<PropTypes> = ({ children, className }) => {
  const [isOpen, setIsOpen] = useSidebar();

  const onChangeWidth = useCallback((matches) => matches && setIsOpen(false), []);

  return (
    <>
      <Portalize container={LEFT_HEADER_PORTAL_ID_HASH}>
        <DrawerButton onClick={(): void => setIsOpen(true)} />
      </Portalize>
      <Media query={SIDEBAR_MEDIA_QUERY_CONFIG} onChange={onChangeWidth} />

      <Aside className={className}>{children}</Aside>

      <Drawer placement="left" open={isOpen} onClose={(): void => setIsOpen(false)}>
        <DrawerBody className={className}>{children}</DrawerBody>
      </Drawer>
    </>
  );
};
